export function extractScripts(element) {
    // Проверяем, что переданный параметр является валидным элементом
    // if (!(element instanceof Element)) {
    //     throw new Error('Invalid element provided.');
    // }

    // Находим все теги <script> внутри указанного элемента
    const scripts = element.querySelectorAll('script');
    
    // Создаем массив для хранения кода из найденных тегов <script>
    const scriptContents = [];

    // Проходим по всем найденным тегам <script>
    scripts.forEach(script => {
        // Добавляем содержимое текущего тега <script> в массив
        scriptContents.push(script.textContent);
    });

    // Возвращаем массив строк с кодом из тегов <script>
    return scriptContents;
}

// // Пример использования функции
// const container = document.getElementById('container'); // Элемент, внутри которого ищем теги <script>
// const scripts = extractScripts(container);
// console.log(scripts); // Выводим массив строк с кодом из тегов <script>